// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BookRouteImport } from './routes/book'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedHomeworkRouteImport } from './routes/_authenticated/homework'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedPaymentHelpRouteImport } from './routes/_authenticated/payment-help'
import { Route as ProgrammesIndexRouteImport } from './routes/programmes/index'
import { Route as ProgrammesSlugRouteImport } from './routes/programmes/$slug'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as ResourcesSlugRouteImport } from './routes/resources/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHomeworkRoute = AuthenticatedHomeworkRouteImport.update({
            id: '/homework',path: '/homework',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentHelpRoute = AuthenticatedPaymentHelpRouteImport.update({
            id: '/payment-help',path: '/payment-help',getParentRoute: () => AuthenticatedRouteRoute
          })
const ProgrammesIndexRoute = ProgrammesIndexRouteImport.update({
            id: '/programmes/',path: '/programmes/',getParentRoute: () => rootRouteImport
          })
const ProgrammesSlugRoute = ProgrammesSlugRouteImport.update({
            id: '/programmes/$slug',path: '/programmes/$slug',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedHomeworkRoute: AuthenticatedHomeworkRoute,AuthenticatedMessagesRoute: AuthenticatedMessagesRoute,AuthenticatedPaymentHelpRoute: AuthenticatedPaymentHelpRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,BookRoute: BookRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,HowItWorksRoute: HowItWorksRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundPolicyRoute: RefundPolicyRoute,ReviewsRoute: ReviewsRoute,TermsRoute: TermsRoute,ProgrammesSlugRoute: ProgrammesSlugRoute,ResourcesSlugRoute: ResourcesSlugRoute,ProgrammesIndexRoute: ProgrammesIndexRoute,ResourcesIndexRoute: ResourcesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)